import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

const UUID_RE = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export function useAuditTrail() {
  const { user } = useAuth();

  const logChange = useCallback(
    async (documentId: string, fieldName: string, oldValue: string | null, newValue: string | null) => {
      const old = (oldValue?.toString() ?? "").trim();
      const nw = (newValue?.toString() ?? "").trim();

      if (!user?.id) return;

      // Master filter: never log identical values
      if (old === nw) return;

      if (!documentId || !UUID_RE.test(documentId)) return;

      const { error } = await supabase.from("audit_logs").insert({
        document_id: documentId,
        field_name: fieldName,
        old_value: old || null,
        new_value: nw || null,
      } as any);
      if (error) console.error("Audit log error:", error.message);
    },
    [user?.id]
  );

  return { logChange };
}
